import { combineReducers } from './utils';
import sharing from './content/sharing';
import sharingStudents from './content/sharing_students';
import content from './content/content';
import wordData from './content/word_data';
import contentSettings from './content/settings';

export default combineReducers({
    sharing,
    sharingStudents,
    content,
    wordData,
    contentSettings,
});



// WEBPACK FOOTER //
// ./src/reducers/content.js